import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { VoucherStore } from '../store/voucher.store';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable()
export class ClientInterceptor implements HttpInterceptor {

  constructor(public voucherStore: VoucherStore) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const clientID = this.getClientByReqAndVoucher(req.url);
    const params:any = {};

    if (clientID) {
      if (!req.url.includes('client_id')) {
        params.params = req.params.append('client_id', clientID);
      }
    }

    const isApiUrl = req.url.startsWith(environment.apiUrl) || 
                     req.url.includes('api.tecnologiaasap.com.br') || 
                     req.url.includes('apiv3.plataformaasap.com.br') || 
                     !req.url.startsWith('http');

    if (isApiUrl) {
      params.setHeaders = {
        'X-Device-Context': 'asap_authorized_access'
      };
      params.withCredentials = true;
      console.log('[ClientInterceptor] Injetando contexto e credenciais para:', req.url);
    } else {
      console.log('[ClientInterceptor] Ignorando URL:', req.url);
    }

    let changeReq = req.clone(params);
    return next.handle(changeReq);
  }

  getClientByReqAndVoucher(url: string): string {
    if (this.isLoginOrRegister(url) && this.voucherStore.state.isValid) {
      return '' + this.voucherStore.state.voucher.client_id;
    }
    return localStorage.getItem('client');
  }

  isLoginOrRegister(url: string): boolean {
    const loginUri = 'oauth/access_token';
    const registerUri = 'v2/client/register';
    const socialUri = 'social_auth/grupo';

    return (url.includes(loginUri) || url.includes(registerUri) || url.includes(socialUri));
  }
}
